<template>
  <div>
    <v-skeleton-loader v-if="stateLoading" :type="type" :min-width="'80px'" />
    <slot name="content" v-else></slot>
  </div>
</template>

<script>
export default {
  name: 'BaseLoadingValue',
  props: {
    stateLoading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
  },
  computed: {},
};
</script>

<style lang="scss"></style>
